import React from "react";
import * as BoxModule from "@mui/material/Box/index.js";
import * as CardMediaModule from "@mui/material/CardMedia/index.js";
import { resolveDefault } from "../../utils/moduleInterop";

const Box = resolveDefault<any>(BoxModule);
const CardMedia = resolveDefault<any>(CardMediaModule);

interface ImageHolderProps {
	alt: string;
	image?: string;
	// title: string;
}

const ImageHolder: React.FC<ImageHolderProps> = ({ alt, image }) => {
	if (!image) {
		return;
	}
	return (
		<Box>
			<CardMedia
				component="img"
				alt={alt}
				image={image}
				// title={title}
				sx={{
					height: "auto",
					objectFit: "cover",
					backgroundSize: "cover",
					position: "relative",
					marginLeft: "auto",
					marginRight: "auto",
				}}
			/>
		</Box>
	);
};

export default ImageHolder;
